import { Collection, Investor } from '@/models';

export class InvestorCollection extends Collection {
    static type = 'InvestorCollection';
    static endpoint = Investor.api.index;
    static model = Investor;
}

export default InvestorCollection;
